import { ReactNode } from 'react';

interface AuthTabPageHeaderProps {
  title: string;
  description: string | ReactNode;
  noBorder?: boolean;
}

const AuthSettingsItemHeader = ({ title, description, noBorder }: AuthTabPageHeaderProps) => {
  return (
    <div className={noBorder ? '' : 'pb-8'}>
      <div className='text-blue-primary pb-2.5 text-xl font-bold'>{title}</div>
      <div className={`text-blue-primary ${noBorder ? '' : 'border-gray-tertiary border-b pb-8'}`}>{description}</div>
    </div>
  );
};

export default AuthSettingsItemHeader;
